import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { withNamespaces } from 'react-i18next'

const ticketPillColors = {
  0: 'transparent',
  1: 'rgba(235, 152, 78, 0.8)',
  2: 'rgba(230, 126, 34, 0.8)',
  active: '#2E5BFF',
  escalated: 'rgba(231, 76, 60, 0.8)'
}

const StyledPreviewInteractionItem = styled.div`
  display: flex;
  flex-direction: column;

  padding: 12px
    ${(props) => (props.withPadding ? props.customPadding || 18 : 0)}px 15px
    ${(props) => (props.withPadding ? props.customPadding || 18 : 0)}px;

  border-bottom: 1px solid #e0e3ee;

  background-color: ${(props) =>
    props.feedback ? 'rgba(174, 214, 241, 0.1)' : 'transparent'};

  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  transition: opacity 0.2s;

  cursor: pointer;

  :hover {
    opacity: 0.8;
  }

  :last-child {
    border-bottom: none;
  }
`

const InteractionTopInfo = styled.div`
  display: flex;
  flex: 1 1 auto;

  color: #2e384d;

  div {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .number {
    width: 10%;
  }
  .subject {
    width: 35%;
    display: flex;
    /* justify-content: space-between; */
    align-items: flex-start;
  }
  .product_name {
    width: 20%;
  }
  .status {
    width: 15%;
  }
  .insert_date {
    width: 20%;
    text-align: right;
  }

  @media (max-width: 678px) {
    .number {
      display: none;
    }
    .subject {
      display: flex;
      /* justify-content: space-between; */
      align-items: flex-start;
      width: 65%;
    }
    .product_name {
      display: none;
    }
    .status {
      width: 15%;
    }
    .insert_date {
      width: 20%;
      text-align: right;
    }
  }
`

const ColoredPill = styled.div`
  border-radius: 8px;
  background-color: ${(props) => props.bgColor};

  color: #fff;
  font-size: 9px;
  padding: 2px 4px;

  margin-left: 5px;
  margin-right: 5px;

  white-space: nowrap;
  /* text-overflow: ellipsis; */
  overflow: visible !important;
`

const InteractionPreviewText = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  padding-top: 3px;

  color: #8b93a7;
`

const InteractionItemMiddle = ({
  interaction,
  t,
  i18n,
  onClickHandler,
  style = {},
  withPadding = true,
  customPadding
}) => {
  const {
    preview,
    number,
    subject,
    product_name,
    status,
    update_date,
    escalated,
    feedback_required,
    severity
  } = interaction

  const ticketPillColor = escalated
    ? ticketPillColors.escalated
    : ticketPillColors[severity]

  return (
    <StyledPreviewInteractionItem
      style={style}
      key={interaction.interaction_id}
      {...interaction}
      onClick={onClickHandler}
      withPadding={withPadding}
      customPadding={customPadding}
      feedback={feedback_required}
    >
      <InteractionTopInfo>
        <div className="number">{number}</div>
        <div className="subject">
          <div>{subject}</div>
          {escalated && (
            <ColoredPill bgColor={ticketPillColor}>Escalated</ColoredPill>
          )}
          {!escalated && severity !== 0 && (
            <ColoredPill bgColor={ticketPillColor}>
              {t(`severity:${severity}`)}
            </ColoredPill>
          )}
        </div>
        <div className="product_name">{product_name}</div>
        <div className="status">{status}</div>
        <div className="insert_date">
          {moment(update_date)
            .locale(i18n.language)
            .fromNow()}
        </div>
      </InteractionTopInfo>
      {preview && <InteractionPreviewText>{preview}</InteractionPreviewText>}
    </StyledPreviewInteractionItem>
  )
}

export default withNamespaces()(InteractionItemMiddle)
